var _circle, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPancake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0138 12.5393C12.6552 10.7243 14.0898 9 15.883 9C17.497 9 18.8419 10.3613 18.8419 11.9948V15.6249C19.2902 15.6249 19.6489 15.6249 20.0972 15.6249C20.4558 15.6249 20.9041 15.6249 21.2628 15.6249V11.9948C21.2628 10.3613 22.6077 9 24.2216 9C26.0149 9 27.4495 10.7243 27.0909 12.5393L26.2839 16.8046C28.9738 17.9844 31.036 20.0717 31.036 22.7035V24.2463C31.036 26.4243 29.6014 28.2393 27.6288 29.4191C25.6562 30.6896 22.9664 31.4157 20.0075 31.4157C17.0486 31.4157 14.3588 30.6896 12.3862 29.4191C10.4136 28.2393 8.979 26.4243 8.979 24.2463V22.7035C8.979 20.0717 11.0412 17.9844 13.7311 16.8046L13.0138 12.5393ZM25.2976 17.4399L26.1942 12.4486C26.4632 11.178 25.4769 9.99827 24.2216 9.99827C23.056 9.99827 22.1594 10.9058 22.1594 12.0856V16.7139C21.8904 16.7139 21.5318 16.6231 21.2628 16.6231C20.9041 16.6231 20.4558 16.6231 20.0972 16.6231C19.6489 16.6231 19.2902 16.6231 18.8419 16.7139C18.5729 16.7139 18.2143 16.8046 17.9453 16.8046V12.1763C17.9453 10.9965 17.0486 10.089 15.883 10.089C14.6277 10.089 13.6415 11.2688 13.9104 12.5393L14.8071 17.6214C11.9379 18.7104 9.96529 20.707 9.96529 22.9758V24.5185C9.96529 27.9671 14.4484 30.7804 20.0075 30.7804C25.5666 30.7804 30.0497 27.9671 30.0497 24.5185V22.9758C30.1394 20.5255 28.1668 18.5289 25.2976 17.4399Z",
    fill: "#633001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1391 24.3369C30.1391 27.7855 25.656 30.5988 20.0969 30.5988C14.5378 30.5988 10.0547 27.7855 10.0547 24.3369V22.7941H30.2288V24.3369H30.1391Z",
    fill: "#FEDC90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9104 12.3579C13.6414 11.0874 14.6277 9.90759 15.8829 9.90759C17.0486 9.90759 17.9452 10.8151 17.9452 11.9949V16.714C18.6625 16.6232 19.3798 16.5325 20.0971 16.5325C20.8144 16.5325 21.5317 16.6232 22.1593 16.6232V11.9949C22.1593 10.8151 23.0559 9.90759 24.2216 9.90759C25.4768 9.90759 26.4631 11.0874 26.1941 12.3579L25.2975 17.3492C28.2564 18.4382 30.229 20.4348 30.229 22.7036C30.229 26.1521 25.7458 28.9654 20.1867 28.9654C14.6277 28.9654 10.1445 26.1521 10.1445 22.7036C10.1445 20.4348 12.1171 18.4382 14.9863 17.3492L13.9104 12.3579Z",
    fill: "#D1884F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3174 22.3406C17.3174 23.2481 16.7795 24.0649 16.2415 24.0649C15.7035 24.0649 15.1655 23.3389 15.1655 22.3406C15.1655 21.4331 15.7035 20.6163 16.2415 20.6163C16.7795 20.6163 17.3174 21.3423 17.3174 22.3406Z",
    fill: "#633001"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0289 22.3406C25.0289 23.2481 24.4909 24.0649 23.9529 24.0649C23.3253 24.0649 22.877 23.3389 22.877 22.3406C22.877 21.4331 23.4149 20.6163 23.9529 20.6163C24.4909 20.6163 25.0289 21.3423 25.0289 22.3406Z",
    fill: "#633001"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPancake);
export default __webpack_public_path__ + "static/media/pancake.9d90c0655466fa42a6cbfa59a0434ce7.svg";
export { ForwardRef as ReactComponent };